<template>
  <div class="margin-top-dollar">
    <div class="flex flex-algin">
      <!--      <span class="icon icon-content">-->
      <!--        <img-->
      <!--          :src="plan_info.company_icon"-->
      <!--          alt="company"/>-->
      <!--      </span>-->
      <!--      <span-->
      <!--        class="icon icon-content"-->
      <!--      >-->
      <!--        <font-awesome-icon-->
      <!--          v-if="formData.class_id"-->
      <!--          :icon="getOptionName('iconOptions', formData.class_id)" />-->
      <!--      </span>-->
      <span class="label break-work">{{ package_name }}</span>
    </div>
    <div class="flex-content">

      <div class="flex-box">
        <div
          v-for="(item, index) in sidebarPremium"
          :key="index"
          class="flex-info">
          <span>{{ item.item }}</span>
          <!--                <span>{{ item.premium | formatMoney(2, true) }}</span>-->
          <span>{{ item.premium_str }}</span>
        </div>
        <!--        <div-->
        <!--          class="flex-info ">-->
        <!--          <span>Manual Discount</span>-->
        <!--          <span>-->
        <!--            <v-input-->
        <!--              v-model="spec_disc_prm"-->
        <!--              prepend="- $"-->
        <!--            ></v-input>-->
        <!--          </span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          class="flex-info ">-->
        <!--          <span>Admin Charge</span>-->
        <!--          <span>-->
        <!--            <v-input-->
        <!--              v-model="handling_fee"-->
        <!--              prepend="+ $"-->
        <!--            ></v-input>-->
        <!--          </span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          v-if="isUseCredit"-->
        <!--          class="flex-info ">-->
        <!--          <span>Credit Point</span>-->
        <!--          <span class="amount">{{'-'+ getCredit |formatMoney(2, true)}}</span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          v-if="getTransactionFee"-->
        <!--          class="flex-info transa-color">-->
        <!--          <span>Transaction Fee</span>-->
        <!--          <span>+{{ getTransactionFee |formatMoney(2, true)}}</span>-->
        <!--        </div>-->
        <div
          class="flex-info total-amount">
          <span>Total Payable</span>
          <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
        </div>
      </div>
      <code-select
        v-if="formData.use_code!=0"
        :orderId="orderId"
        :notApply="true"
        :isQuote="false"
        :customerId="customerId"
        :customer="formData.customer"
        :is-user="true"
        :useCode = "formData.use_code"
        @check-code="applyCode"
      ></code-select>
    </div>
    <coupon-dialog
      ref="coupon-dialog"
      :customerId="customerId"
      :customer="formData.customer"
      :orderId="orderId"
      @coupon="computedCoupon">
    </coupon-dialog>
  </div>
</template>

<script>

import CodeSelect from '@/views/components/code-select'
import CouponDialog from '@/views/quoting/dialogs/coupon-dialog'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import {applyOrderCode, verifyPromoCode} from '@api/order'
import {mapActions} from 'vuex'

export default {
  name: 'premiumSide',
  components:{
    CodeSelect,
    CouponDialog,
  },
  mixins: [MixinOptions, MixinFormat],
  props:{
    sidebarInfo:{
      type: Object,
      default:()=>({})
    },
    customerId:{
      type: Number,
      default:''
    },
    form:{
      type: Object,
      default: () => {}
    }
  },
  data(){
    return{
      amount: '',
      spec_disc_prm:'',
      handling_fee:'',
      formData:{

      },
      premium_info:[]
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode','selectCode']),

    orderId() {
      return this.$route.query.order_id
    },
    package_name(){
      let {package_info={}} = this.sidebarInfo
      let {package_name=''} = package_info
      return package_name
    },
    amountResult() {
      let total =  this.premium_info.find(item => item.name == 'paid')||{}
      return this.amount === ''? Number(total.premium): Number(this.amount)
    },
    plan_info(){
      let {premium_info} = this.sidebarInfo||{}
      return premium_info||{}
    },
    sidebarPremium() {
      if(!this.premium_info) {
        return []
      }
      // let {spec_disc_prm,handling_fee} = this.formData
      // this.spec_disc_prm = spec_disc_prm
      // this.handling_fee  =handling_fee
      let premium = this.premium_info.filter(item => item.name != 'paid'&&item.name!='handling_fee'&&item.name!='spec_disc_prm')
      return  premium
    },
  },
  watch:{
    sidebarInfo:{
      immediate:true,
      handler(val){
        if(val){
          let{premium_info=[]} = val
          this.premium_info = premium_info
        }
      }
    }
  },
  methods:{
    ...mapActions('coupon', ['setSelectCode']),
    applyCode(){
      this.network().verifyPromoCode()
    },
    computedCoupon(data){
      this.coupon = data
      this.formData.coupon = data
      this.applyCode()
    },
    handlerSetCode(){
      let {coupon,code,coupon_code,referrer, referrer_user_id} = this.form
      let params ={}
      if(coupon_code){
        params.coupon = {selectCode:1,...coupon}
        // this.setSelectCode ({selectCode:1,...coupon})
      }
      if(code){
        params.code = {selectCode:2,code, referrer, referrer_user_id}

      }
      this.setSelectCode(params)
    },
    network(){
      return {
        verifyPromoCode: async () => {
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.customerId,
              code: this.code
            })
            if (data.code == 1000) {
              this.network().applyOrderCode()
            }
          } else {
            this.network().applyOrderCode()
          }

        },
        applyOrderCode: async () => {
          let {selectCode, coupon = {}, code = {}} = this.selectCode || {}
          let params = {}
          if (coupon.selectCode == 1) {
            params.coupon = coupon.coupon_code
          }
          if (code.selectCode == 2) {
            params.code = code.code
          }
          const {dataCode} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            ...params
          })
          this.$emit('updatePremium')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.margin-top-dollar{
  margin-top: 30px;
  .flex-algin{
    //align-items: center;
    margin-bottom: 10px;
    width: 280px;
    .label{
      margin-top: 0;
      word-break: break-word;
    }
    .icon{
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
  }
  .flex-content {
    width: 280px;
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;

        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
          width: 50%;
        }

        span:last-child {
          color: #24292E;
          font-size: 14px;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
  }
}

</style>
